import apiCall from "../../utils/apiCall";
import {apiUrls} from "../../constants/apiUrls";
import {CreateGarage} from "../../types/api/guide/garage.types";

export const garageService = {
    getAll: () =>
        apiCall.get(apiUrls.guide.garage.getAll),

    create: (garage: CreateGarage) =>
        apiCall.post(apiUrls.guide.garage.create, garage),
}